export default __webpack_public_path__ + "static/sneakers4.inspirations-d9cea2964e43c7c97be63687156480b7.jpg";